import { useApp } from '@tldraw/editor'
import { track } from 'signia-react'
import { useActions, useReadonly, useTranslation } from '../../hooks'
import { Button, kbdStr } from '../primitives'

export const TrashButton = track(function TrashButton() {
	const app = useApp()
	const actions = useActions()
	const msg = useTranslation()
	const action = actions['delete']

	const isReadonly = useReadonly()
	if (isReadonly) return null

	const noSelected = app.selectedIds.length <= 0

	return (
		<Button
			icon={action.icon}
			onClick={action.onSelect}
			disabled={noSelected}
			title={`${msg(action.label!)} ${kbdStr(action.kbd!)}`}
			smallIcon
		/>
	)
})
